import {Field} from './crud/Field';
import {ModalFields} from './modal-fields';
import {Config} from './crud/Config';
import {TimeTrackerService} from '../app/time-tracker-service.service';

export class User {
    public id: string;

    public username: string;
    public email: string;
    public photoUrl: string;
    public ci: string;
    public userType: string;
    public companyId: string;
    public teamId: string;
    public active: boolean;
    public isAdmin: boolean;

    // No model fields
    public device: any;
    public schedule: any;
    // No model fields, used for registration
    public password: string;
    public repeat_password: string;
    public checks: Array<any>;

    constructor() {
    }


    public static toModelTemplate(user: User) {

        const path = TimeTrackerService.USERS;

        const idField = new Field('id', 'id', 'text', false);
        const usernameField = new Field('MODEL.USER.USERNAME', 'username', 'text', true);
        const ciField = new Field('MODEL.USER.CI', 'ci', 'text', true);
        const userTypeField = new Field('MODEL.USER.USER_TYPE', 'userType', 'select', true);
        const companyIdField = new Field('CompanyID', 'companyId', 'text', true);
        const teamIdField = new Field('TeamId', 'teamId', 'text', true);
        const activeField = new Field('MODEL.USER.ACTIVE', 'active', 'checkbox', false);

        // New admin users set PLANT_WORKER
        userTypeField.entries = [
            {key: 'PENDING', value: 'USER_TYPES.PENDING'},
            {key: 'PLANT_WORKER', value: 'USER_TYPES.PLANT_WORKER'},
            {key: 'INTERN', value: 'USER_TYPES.INTERN'},
            {key: 'EXTERNAL', value: 'USER_TYPES.EXTERNAL'}
        ];

        idField.hidden = true;
        companyIdField.hidden = true;
        teamIdField.hidden = true;

        if (user != null) {
            idField.value = user.id;
            usernameField.value = user.username;
            ciField.value = user.ci;
            userTypeField.value = user.userType;
            companyIdField.value = user.companyId;
            teamIdField.value = user.teamId;
            activeField.value = user.active;
        }

        const modalFields = new ModalFields(
            [idField, usernameField, ciField, userTypeField, companyIdField, teamIdField, activeField],
            new Config(''),
            false, false, false
        );

        modalFields.firebaePath = path;
        return modalFields;
    }
}



// WEBPACK FOOTER //
// ./src/models/User.ts